// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__9L-eB","paramInput":"JobSimulator_paramInput__2Y9Ur","input":"JobSimulator_input__207GH"};